export enum LaptopTransportType {
    Consultant = 1,
    Loggi = 2,
    Dhl = 3
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/LaptopTransportType.ts